import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {AuthService} from "@shared/services/security/auth.service";

export const authGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const authService = inject(AuthService);
    if (authService.isUserLogged) {
        return true; // User is authenticated, allow access
    } else {
        router.navigate(['/signin']);
        return false;
    }
};
